<template>
    <div>
        <div class="card sc-hero">
            <div class="card-title">{{ clientName }}</div>
            <div class="sc-counter">
                <div class="sc-counter-icon"><i class="fa-solid fa-people-group"></i></div>
                <div class="sc-counter-value">{{ loaded ? count : '–' }}</div>
                <div class="sc-counter-label">{{ $t('peopleCurrentlyInside') }}</div>
            </div>
        </div>

        <div v-if="workingHours" class="card">
            <div class="card-title">{{ $t('sportsCenterHours') }}</div>
            <div class="sc-hours">
                <div v-for="row in scheduleRows(workingHours)" :key="row.day" class="sc-hours-row">
                    <span class="sc-hours-day">{{ row.label }}</span>
                    <span class="sc-hours-times">{{ row.text }}</span>
                </div>
            </div>
        </div>

        <div v-if="receptionWorkingHours" class="card">
            <div class="card-title">{{ $t('receptionHours') }}</div>
            <div class="sc-hours">
                <div v-for="row in scheduleRows(receptionWorkingHours)" :key="row.day" class="sc-hours-row">
                    <span class="sc-hours-day">{{ row.label }}</span>
                    <span class="sc-hours-times">{{ row.text }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SportsCenterView',
    data() {
        return {
            count: 0,
            loaded: false,
            // Each schedule is an object keyed by ISO day (1-7, 8 = holiday) with {from, to} intervals, or null
            // when nothing is configured - in which case its card is hidden entirely.
            workingHours: null,
            receptionWorkingHours: null,
            // Handle for the auto-refresh timer so it can be cleared when leaving the screen.
            timer: null
        };
    },
    computed: {
        clientName() {
            const client = this.$store.getters.selectedClient;
            if (!client) return '';
            return client.sport_center_name || client.name;
        }
    },
    mounted() {
        this.load();
        // Keep the counter roughly live while the screen is open; cleared on unmount.
        this.timer = setInterval(() => this.load(false), 15000);
    },
    unmounted() {
        if (this.timer) clearInterval(this.timer);
    },
    methods: {
        // The periodic refresh runs without the loader overlay so the number just ticks quietly.
        async load(loader = true) {
            const response = await this.$api.get('occupancy', null, { loader });
            if (response.success) {
                this.count = response.data.count;
                this.workingHours = response.data.working_hours;
                this.receptionWorkingHours = response.data.reception_working_hours;
                this.loaded = true;
            }
        },
        // Turns a schedule object into ordered rows (only days that have hours), each with a localised day label
        // and its intervals joined as "HH:MM – HH:MM".
        scheduleRows(schedule) {
            const labels = this.$strings.weekdaysLong;
            const rows = [];
            for (let day = 1; day <= 8; day++) {
                const intervals = schedule[day];
                if (!Array.isArray(intervals) || intervals.length === 0) continue;
                rows.push({
                    day,
                    label: labels[day],
                    text: intervals.map((i) => i.from + ' – ' + i.to).join(', ')
                });
            }
            return rows;
        }
    }
};
</script>
